import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/lib/auth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const params = new URLSearchParams(location.hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }
        axios
            .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
            .then((res) => setUser(res.data))
            .catch(() => {})
            .finally(() => {
                navigate(window.location.pathname, { replace: true });
            });
    }, [location.hash, navigate, setUser]);

    // Silent processing: no loading UI, immediate redirect after session exchange
    return null;
};

export default AuthCallback;
